import React from 'react';
// import PropTypes from 'prop-types';
// import { bindActionCreators } from 'redux';
import { connect } from 'react-redux';

/*
import {
  getAPIData
} from './actions';
*/

/*
import {
  selectApiData
} from './selectors';
*/

// IMPORTS DE ESTILOS E IMAGENES:
import './style.scss';

/*
const getMyIp = (apiData) => (
  (apiData && apiData.origin) && apiData.origin.split(', ')[1]
);
*/

/**
 * Representa el componente container Home
 *
 * @class HomePage
 * @extends {React.Component}
 */
export class HomePage extends React.Component {

  componentWillMount() {
    /*
    const { actions } = this.props;

    actions.getAPIData();
    */
  }

  render() {
    /*
    const {
     apiData
    } = this.props;
    */

    return (
      <div className="home">
          {
            /*
            <p className="home-intro">
              To get started, edit &nbsp;
              <code>
                src/containers/HomePage/index.js
              </code>
              &nbsp;and save to reload.
            </p>
            <p className="home-intro">
              Your IP is:
              {
                getMyIp(apiData)
              }
            </p>
            */
          }
      </div>
    );
  }
}

/*
HomePage.defaultProps = {
  apiData: {}
};

HomePage.propTypes = {
  actions: PropTypes.object.isRequired,
  apiData: PropTypes.object
};

const mapStateToProps = (state) => ({
  apiData: selectApiData(state)
});

const mapDispatchToProps = (dispatch) => ({
  actions: bindActionCreators({
    getAPIData
  }, dispatch)
});
*/

export default connect(() => ({}), () => ({}))(HomePage);



// WEBPACK FOOTER //
// ./src/containers/HomePage/index.js